export default __webpack_public_path__ + "static/LockClosed-18281e85ee8523db807bb04889ceaac8.png";